import { WixOOISDKAdapter } from '@wix/bookings-adapter-ooi-wix-sdk/dist/src/WixOOISDKAdapter';
import { CatalogServiceDto } from '@wix/bookings-uou-types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import {
  createServiceImageViewModel,
  ServiceImageViewModel,
} from './serviceImageViewModel/serviceImageViewModel';
import {
  BodyViewModel,
  createBodyViewModel,
} from './bodyViewModel/bodyViewModel';
import { createFilterOptions } from './filterOptions/filterOptions';
import { createHeaderViewModel } from './headerViewModel/headerViewModel';
import { getServices } from './services/services';
import {
  FilterOption,
  Resources,
  ServiceListLayoutOptions,
  ViewMode,
} from '../types/types';
import { BusinessInfo as LegacyBusinessInfo } from '../../legacy/types';
import { getServiceListLayout } from '../utils/layouts/layouts';
import { CoursesAvailability } from '../actions/courseAvailability/CoursesAvailability';

export type WidgetViewModel = {
  services: CatalogServiceDto[];
  businessInfo: LegacyBusinessInfo;
  filterOptions: FilterOption[];
  serviceImageViewModel: ServiceImageViewModel;
  headerViewModel?: any;
  bodyViewModel: BodyViewModel;
  showDialog: boolean;
  seo?: {
    shouldListServicesFromOtherCategories: boolean;
    allServices: CatalogServiceDto[];
  };
  serviceListLayout: ServiceListLayoutOptions;
  coursesAvailability?: CoursesAvailability;
};

export const createWidgetViewModel = async ({
  filteredResources,
  businessInfo,
  wixSdkAdapter,
  flowAPI,
  scale,
  viewMode,
  isAnywhereFlow = false,
}: {
  filteredResources: Resources;
  businessInfo: LegacyBusinessInfo;
  flowAPI: ControllerFlowAPI;
  wixSdkAdapter: WixOOISDKAdapter;
  scale: number;
  viewMode: ViewMode;
  isAnywhereFlow?: boolean;
}): Promise<WidgetViewModel> => {
  const {
    settings,
    environment: { isMobile },
    experiments,
  } = flowAPI;
  const allServices = filteredResources.offerings;

  const filterOptions = createFilterOptions({
    flowAPI,
    filteredResources,
    wixSdkAdapter,
  });

  const services = await getServices({
    filterOptions,
    filteredResources,
    settings,
    isAnywhereFlow,
  });

  const serviceListLayout = getServiceListLayout({
    settings,
    experiments,
    isMobile,
  });

  const serviceImageViewModel = createServiceImageViewModel({
    settings,
    isMobile,
    serviceListLayout,
  });

  const bodyViewModel = createBodyViewModel({
    settings,
    scale,
    imageAspectRatio: serviceImageViewModel.aspectRatio,
    isMobile,
    serviceListLayout,
  });

  const headerViewModel = createHeaderViewModel(settings, filterOptions);

  const shouldListServicesFromOtherCategories =
    viewMode === ViewMode.PAGE && services.length !== allServices.length;
  const seo = {
    shouldListServicesFromOtherCategories,
    allServices,
  };

  return {
    services,
    filterOptions,
    showDialog: false,
    serviceListLayout,
    serviceImageViewModel,
    headerViewModel,
    bodyViewModel,
    businessInfo,
    seo,
  };
};
